var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('side-panel-inner',{staticClass:"p-form-create",attrs:{"headerTitle":"Responses"}},[_c('ul',_vm._l((_vm.responses),function(response){return _c('li',{key:response.id},[_c('base-question-response',{attrs:{"response":response}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }